// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3WFcZ","content":"LoadingAlert_content__2RyRN"};